module.exports = __webpack_public_path__ + "src/assets/img/progroup-1.36eb9d5a.png";